import React from 'react';
import { inject, observer } from "mobx-react";
import { withRouter} from 'react-router-dom';
import Language from '../language/language'
import { Table } from 'antd'
// import { $const } from '../../helper'

// import './stylesheets/controlCenter.scss'

const { Column } = Table;


@inject('commonStore')
@withRouter
@observer
export default class IndividualEventsList extends React.Component {
  goDetail = (record) => {
    this.props.commonStore.gTag("event", "viewEvents", {
      pageName: "controlCenter",
      buttonName: '查看',
    });
    this.props.history.push(`/personGame-apply-info/${record.id}`)
  }
  render () {
    const events = this.props.events
    return (
      <div className="individual-events-list">
        <Table dataSource={events} rowKey="id" title={()=><Language resource="EVENTS_CONTROL" />}>
              <Column 
                title={<Language resource="EVENTS_NAME" />}
                dataIndex="gameName"
                key="gameName"
              >
              </Column>
              <Column 
                title={<Language resource="CURRENT_STAGE" />}
                dataIndex="currentStage"
                key="currentStage"
              >
              </Column>
              <Column 
                title={<Language resource="CURRENT_STATUS" />}
                dataIndex="currentStatus"
                key="currentStatus"
              >
              </Column>
              <Column 
                title={<Language resource="DETAIL" />}
                key="action"
                render={(text, record) => (
                  <div className="action">
                    <div className="spe-link" onClick={this.goDetail.bind(this, record)}>
                      <Language resource="VIEW" ></Language>
                    </div>
                  </div>
                )}
              >
              </Column>
          </Table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/controlCenter/individualEventsList.js